import axios from 'axios';
import configJson from '../../../config/default.json';

const state = {
	nome: 'AZ SELLER',
	drawer: false,
	drawerFilter: false,
	existFilter: false,
	url: process.env.VUE_APP_URL_API,
	cloudfront: process.env.VUE_APP_AWS_CLOUDFRONT,
	version: configJson.version,
	env: process.env.NODE_ENV,
	//url: 'https://azseller-env-1.eba-jy62qrrm.eu-west-1.elasticbeanstalk.com/api/v1/',
	urlsocket: process.env.VUE_APP_URL_SOCKET,
	//urlsocket: 'https://azseller-env-1.eba-jy62qrrm.eu-west-1.elasticbeanstalk.com:4000/',
	//url: 'https://fi1w2iozdf.execute-api.eu-west-1.amazonaws.com/dev/api/v1/',
	dialog: false, // Gestione pop Up
	subDialog: false, // Gestione pop Up
	thirdDialog: 0, // Gestione pop Up
	subLayerDialog: false,
	subOperationLayerDialog: false,

	messages: {}, // testo messaggio
	errors: {}, // collezione errori
	preload: false,
	operation: '',
	subOperation: '',
	textMessage: '',
	statusMessage: false,
	setting: {},
	snackbar: {
		snackbar: false,
		color: '',
		mode: false,
		timeout: '-1',
		vertical: true,
		text: 'test',
		centered: true,
	},
	service: [
		'mws',
		'googleMap',
		'AmazonAdvertising',
		'magento',
		'fattureInCloud',
		'paypal',
		'stripe',
		'aws',
		'googletranslate',
		'aliexpress',
		'store',
		'prestashop',
		'shopify',
		'woocommerce',
		'website',
		'spedisciOnline',
		'gls',
		'bartolini',
		'dhl',
		'ups',
		'barcode',
		'qrcode',
		'yoast',
	],
};

const getters = {
	getDrawer: state => {
		return state.drawer;
	},
	getName: state => {
		return state.nome;
	},
	getVersion: state => {
		return state.version;
	},
	getNodeEnv: state => {
		return state.env !== 'production' ? `- [ENV] ${state.env.toUpperCase()}` : '';
	},
	getUrl: state => {
		return state.url;
	},
	getSocket: state => {
		return state.urlsocket;
	},
	getDialog: state => {
		return state.dialog;
	},
	getSubDialog: state => {
		return state.subDialog;
	},
	getSubLayerDialog: state => {
		return state.subLayerDialog;
	},
	getSubOperationLayerDialog: state => {
		return state.subOperationLayerDialog;
	},
	getThirdDialog: state => {
		return state.thirdDialog;
	},
	getOperation: state => {
		return state.operation;
	},
	getSubOperation: state => {
		return state.subOperation;
	},
	getPreload: state => {
		return state.preload;
	},
	getErrors: state => {
		return state.errors;
	},
	getMessages: state => {
		return state.messages;
	},
	getDrawerFilter: state => {
		return state.drawerFilter;
	},
	getExistFilter: state => {
		return state.existFilter;
	},
	getTextMessage: state => {
		return state.textMessage;
	},
	getStatusMessage: state => {
		return state.statusMessage;
	},
	getSetting: state => {
		return state.setting;
	},
	getSnackbar: state => {
		return state.snackbar;
	},
};

const actions = {
	/*resetMessages : (context) => {
        console.log(context);
        context.commit('setMessages',{});

    },*/
	asyncFetchData: async context => {
		// console.log("setting",_.size(context.rootGetters['settings/getSetting']))
		//console.log('context', context.rootGetters['settings/getSetting']);
		if (_.size(context.rootGetters['settings/getSetting']) > 0) {
			return context.rootGetters['settings/getSetting'];
		} else {
			let url = 'profile/setting';
			//console.log(`${context.rootGetters['settings/getUrl']}${url}`)fetchAllPermissions
			return axios
				.get(
					`${context.rootGetters['settings/getUrl']}${url}`,

					{
						headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
						'Content-Type': 'application/json',
					},
				)
				.then(success => {
					//console.log('h', success.data);

					context.commit('settings/setSetting', success.data.data, { root: true });

					return success.data.data;
				})
				.catch(error => {
					console.log(error);

					return error.response;
				});
		}
	},
	getSettingManual: async (context, payload) => {
		let url = 'profile/settingmanual';
		const responsesestting = [];
		payload.forEach(el => {
			//const findSetting =
		});
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {
				// console.log("h",success.data)

				return success.data.data;
			})
			.catch(error => {
				console.log(error);

				return error.response;
			});
	},

	fetchAllPermissions: async context => {
		let url = 'profile/all-permissions';
		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {
				// console.log("h",success.data)

				return success.data.data;
			})
			.catch(error => {
				console.log(error);

				return error.response;
			});
	},
	updatePermissions: async (context, payload) => {
		let url = 'profile/update-permissions';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {
				// console.log("h",success.data)

				return success.data.data;
			})
			.catch(error => {
				console.log(error);

				return error.response;
			});
	},
	updateData: async (context, setting) => {
		context.commit('setSetting', setting);
	},
	destroyData: context => {
		//context.commit('setSetting', []);
	},
	updateSnackbar: async (context, setting) => {
		context.commit('setSnackbar', setting);
	},
};

const mutations = {
	setDrawer: (state, value) => {
		state.drawer = value;
	},
	setDialog: (state, value) => {
		state.dialog = value;
	},
	setSubDialog: (state, value) => {
		state.subDialog = value;
	},
	setThirdDialog: (state, value) => {
		state.thirdDialog = value;
	},
	setSubLayerDialog: (state, value) => {
		state.subLayerDialog = value;
	},
	setOperation: (state, value) => {
		state.operation = value;
	},
	setSubOperation: (state, value) => {
		state.subOperation = value;
	},
	setSubOperationLayerDialog: (state, value) => {
		state.subOperationLayerDialog = value;
	},
	setPreload: (state, value) => {
		state.preload = value;
	},
	setErrors: (state, value) => {
		state.errors = value;
	},
	setMessages: (state, value) => {
		//console.log(value);
		if (value) {
			state.messages[value.key] = value.value;
		} else {
			state.messages = {};
		}
	},
	setClearError: state => {
		state.errors = {};
	},
	setDrawerFilter: (state, value) => {
		state.drawerFilter = value;
	},
	setExistFilter: (state, value) => {
		state.existFilter = value;
	},
	setTextMessage: (state, value) => {
		state.textMessage = value;
	},
	setStatusMessage: (state, value) => {
		state.statusMessage = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},
	setSnackbar: (state, value) => {
		state.snackbar = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
